import React from "react";
//#region types
import { IncomingInvoiceStatusTagsProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceEnums } from "models/enums";
//#endregion
//#region components
import { Tags } from "components/common";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const IncomingInvoiceStatusTags: React.FC<IncomingInvoiceStatusTagsProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const viewState = incomingInvoiceService.toViewState(props.status);

  const getLabelClass = (status: IncomingInvoiceEnums.ViewState) => {
    switch (status) {
      case IncomingInvoiceEnums.ViewState.ToApprove:
      case IncomingInvoiceEnums.ViewState.ToFinalApproval:
        return cssExports.yellowTag;
      case IncomingInvoiceEnums.ViewState.InProcess:
      case IncomingInvoiceEnums.ViewState.Unhandled:
        return cssExports.blueTag;
      case IncomingInvoiceEnums.ViewState.InBook:
        return cssExports.greenTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[incomingInvoiceService.getStateText(viewState)]} className={getLabelClass(viewState)} />;
};

export default IncomingInvoiceStatusTags;
